import { moduleProviderFactory } from 'core/providers';
import { InventoryList } from 'modules/product-inventory/pages';
import { InventorySync } from 'modules/product-inventory/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.inventory',
				pattern: '/inventory',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.inventory.list',
						pattern: '',
						authorization: 'inventorySection.read',
						component: InventoryList,
					},
					{
						name: 'master.app.main.inventory.inventorysync',
						pattern: '/inventory-sync',
						authorization: 'inventorySection.full',
						component: InventorySync
					},
				],
			},
		],
	});
})();



// WEBPACK FOOTER //
// ./src/modules/product-inventory/config.js